const doesVideoThumbnailNeedOverlay = (url?: string) => {
    if (url) {
        let domain = new URL(url);
        const videoTypeDomain = domain.hostname.replace("www.", "");
        return videoTypeDomain === "youtube.com";
    }
};

const stopVideo = (fullWidth?: boolean) => {
    const selector = fullWidth ? "product-video--full-width" : "product-video";
    const productVideoIframes = document.querySelectorAll(`iframe.${selector}`);

    productVideoIframes.forEach(iFrameElement => {
        const iframe = iFrameElement as HTMLIFrameElement;
        if (iframe) {
            let iframeSrc = iframe.src;
            iframe.src = iframeSrc;
        }
    });
};

export { doesVideoThumbnailNeedOverlay, stopVideo };
